import React from 'react';

/**
 * RateLimitNotice — calm Cormorant-italic notice rendered above auth forms
 * when the backend returns 429. Same visual language as the storage warning
 * banner: warm amber, soft border, no destructive red, no exclamation icons.
 *
 * Props:
 *   - message: localized backend `detail` string. If empty, renders null.
 *   - testId:  optional override for data-testid (default: 'rate-limit-notice').
 */
const RateLimitNotice = ({ message, testId = 'rate-limit-notice' }) => {
  if (!message) return null;
  return (
    <div
      role="status"
      data-testid={testId}
      style={{
        background: '#fbf5e8',
        border: '1px solid #e5c97a',
        color: '#6b5520',
        padding: '14px 18px',
        margin: '0 0 18px',
        fontFamily: 'Cormorant Garamond, Playfair Display, serif',
        fontStyle: 'italic',
        fontSize: 15,
        lineHeight: 1.55,
        textAlign: 'center',
      }}
    >
      {message}
    </div>
  );
};

export default RateLimitNotice;
